import React from 'react'
import Head from 'next/head'
import { red } from '@mui/material/colors'

const primary = red[600]

type Props = { title?: string; description?: string }

const Seo = ({ title, description }: Props) => {
  const defaultDescription =
    'The East Riding of Yorkshire Portal for the data collection.'
  const defaultTitle = 'East Riding of Yorkshire Portal'
  return (
    <Head>
      <title>{title ? `${title} | ${defaultTitle}` : defaultTitle}</title>
      <meta httpEquiv="content-language" content="en" />
      <meta
        name="description"
        content={
          description
            ? `${description} || ${defaultDescription}`
            : defaultDescription
        }
      />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta httpEquiv="Content-Type" content="text/html; charset=ISO-8859-1" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" type="image/x-icon" href="favicon.ico" />
      <meta name="application-name" content="&nbsp;" />
      <meta name="msapplication-TileColor" content={primary} />
    </Head>
  )
}

export default Seo
